import Label from "../Label";
import PopUp from "../PopUp";
import PromoContent from "../PromoContent";

export default function PromoPopup({ onClose }) {
  return (
    <PopUp className="promo-popup">
      <div className="promo-popup-header">
        <h1>
          <Label number={157} />
        </h1>
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
      </div>
      <div className="promo-popup-content">
        <PromoContent />
      </div>
    </PopUp>
  );
}
